import { UserContext } from '@providers/userContextProvider';
import type { FlagsmithFlags } from '@utils/flagsmith';
import { useContext, useMemo } from 'react';

export const useFeatureFlag = (flag: FlagsmithFlags) => {
  const { featureFlags } = useContext(UserContext);

  return useMemo(() => featureFlags.has(flag), [featureFlags, flag]);
};

export const useFeatureFlagsResolved = () => {
  const { featureFlagsResolved } = useContext(UserContext);

  return featureFlagsResolved;
};
